import React from "react";
import { Link, useHistory } from "react-router-dom";
import "../scss/order-toolbar.scss";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const OrderToolbar = () => {
  const history = useHistory();
  return (
    <div className="toolbar-wrapper">
      <div className="toolbar">
        <Link to="/" className="link">
          <div className="toolbar-brand"></div>
        </Link>
        <span>Passer une commande</span>
        <ArrowBackIcon onClick={() => history.goBack()} />
        <button onClick={() => history.goBack()}>Retour</button>
      </div>
    </div>
  );
};

export default OrderToolbar;
